<template>
  <el-dialog
    ref="runningplanEdit"
    :title="title"
    :visible.sync="visible"
    width="68%"
    :before-close="handleClose"
    :append-to-body="true"
  >
    <el-form ref="form" :model="form" size="small">
      <div class="tipsBox" style="margin: 0 0 5px 90px">
        <img style="width: 20px; height: 20px" src="./static/tips.png" />
        <span>若该班次未产生订单，可修改班次时间！</span>
      </div>
      <el-form-item label="班次时间：">
        <el-row :gutter="20">
          <el-col :span="6">
            <avue-date
              type="date"
              format="yyyy-MM-dd"
              valueFormat="yyyy-MM-dd"
              v-model="form.departureDate"
            />
          </el-col>
          <el-col :span="6" style="display: flex">
            <el-time-picker
              v-if="!timeRangeShow"
              :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
              value-format="HH:mm"
              format="HH:mm"
              placeholder="请选择班次时间"
              size="small"
              v-model="form.departureTime"
              @change="handlePlanTime"
              key="pickerRangeType"
              :clearable="false"
            />
            <el-time-picker
              v-else
              key="pickerType"
              is-range
              v-model="form.timeRange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              placeholder="选择时间范围"
              format="HH:mm"
              :clearable="false"
              value-format="timestamp"
              style="width: 200px"
              @change="timeRangeChange($event)"
            />
            <el-button
              style="margin-left: 10px"
              type="text"
              @click="timeRangeShow = !timeRangeShow"
              v-has-permi="['transport_runningplan_range']"
            >
              {{ timeRangeShow ? '返回' : '区间发班' }}
            </el-button>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="班次状态：">
        <avue-select
          placeholder="请选择班次状态"
          v-model="form.status"
          :dic="[
            { label: '开班', value: 1 },
            { label: '停班', value: 2 }
          ]"
        />
        <div class="tipsBox" style="display: inline-block; margin-left: 10px">
          <img style="vertical-align: middle; width: 20px; height: 20px" src="./static/tips.png" />
          <span>停班后乘客不可选择该班次下单！</span>
        </div>
      </el-form-item>
      <div class="tipsBox" style="margin-left: 5px">
        <img style="width: 20px; height: 20px" src="./static/tips.png" />
        <span>价格方案和车座相关，请谨慎修改，可在详情页点击修改价格！</span>
      </div>
      <el-form-item label="价格方案：">
        <el-row :gutter="20">
          <el-col :span="4">
            <avue-select
              placeholder="请选择座位"
              v-model="form.seat"
              :dic="seatDic"
              :props="{ label: 'seatName', value: 'seats' }"
              @change="handleSeateNumSelect"
            />
          </el-col>
          <el-col :span="4">
            <avue-select
              placeholder="请选择车型"
              :disabled="carTypeDisabled"
              v-model="form.carType"
              :props="{ label: 'carType', value: 'type' }"
              :dic="carTypeDic"
              @change="handleSelectPriceMthod"
            />
          </el-col>
          <el-col :span="6">
            <avue-select
              placeholder="请选择价格方案"
              v-model="form.priceMethodId"
              :props="{ label: 'priceMethodName', value: 'priceMethodId' }"
              :dic="priceMethodDic"
            />
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="站点开关：" v-if="false">
        <div class="tipsBox" style="margin: 0 0 5px 0px">
          <img style="width: 20px; height: 20px" src="./static/tips.png" />
          <span>站点关闭后乘客无法在该站点下单，谨慎关闭！</span>
        </div>
        <el-table :data="data" border size="small" max-height="200px">
          <el-table-column label="序号" align="center" width="80">
            <template slot-scope="scope">
              {{ scope.row.index + 1 }}
            </template>
          </el-table-column>
          <el-table-column label="类型" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.index === start">起点</div>
              <div v-if="scope.row.index > start && scope.row.index < end">经过</div>
              <div v-if="scope.row.index === end">终点</div>
            </template>
          </el-table-column>
          <el-table-column label="站点名称" align="center" prop="stationName" />
          <el-table-column label="上下车规则" align="center">
            <template slot-scope="scope">
              {{ scope.row.rule }}
            </template>
          </el-table-column>
          <el-table-column label="是否关闭站点" align="center">
            <template slot-scope="scope">
              <avue-switch
                active-color="#13ce66"
                v-model="scope.row.enable"
                :dic="[{ value: 2 }, { value: 1 }]"
              />
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="运力信息：">
        <el-button type="text" size="small" @click="handleMmpVar(info)">调整运力</el-button>
        <modify-driver v-if="modifyDriverDialog" ref="modifyDriver" @refreshData="refreshData" />

        <el-table :data="form.capacityInfoVOS" border size="small" max-height="200px">
          <el-table-column label="出车顺序" align="center" prop="sort" />
          <el-table-column label="状态" align="center" prop="driverStatus" />
          <el-table-column label="司机姓名" align="center" prop="driverName" />
          <el-table-column label="司机电话" align="center" prop="driverPhoneNum" />
          <el-table-column label="车牌号" align="center" prop="carNum" />
          <el-table-column label="车型" align="center" prop="carType" />
        </el-table>
      </el-form-item>
      <el-form-item label="标签：">
        <el-popover placement="bottom" width="160" trigger="manual" v-model="labelVisible">
          <div
            style="padding: 0px 0px 20px 20px; max-height: 200px; overflow-y: scroll"
            v-loading="labelLoading"
          >
            <el-checkbox-group :max="2" v-model="labelCheck">
              <div
                v-for="item in labelCheckList"
                :key="item.label"
                style="display: flex; justify-content: space-between; align-items: center"
              >
                <el-checkbox :label="item.type">{{ item.name }}</el-checkbox>
                <el-button
                  size="mini"
                  type="text"
                  icon="el-icon-edit"
                  v-has-permi="['edit_label']"
                  @click="handleAdd(item, 'edit')"
                >
                  编辑
                </el-button>
              </div>
            </el-checkbox-group>
          </div>
          <div class="flex flex-justify-between">
            <div>
              <el-button
                size="mini"
                type="text"
                v-has-permi="['add_label']"
                @click="handleAdd({}, 'add')"
              >
                添加
              </el-button>
            </div>
            <div>
              <el-button size="mini" type="text" @click="labelVisible = false">取消</el-button>
              <el-button type="primary" size="mini" @click="submitLabel()">确定</el-button>
            </div>
          </div>
          <el-button slot="reference" type="text" class="add-labels" @click="addLabels">
            添加
          </el-button>
        </el-popover>
        <span>
          <el-tag
            v-for="(item, index) in labels"
            :key="index"
            closable
            type="warning"
            size="small"
            style="margin-right: 5px"
            @close="handleCloseLabel(index)"
          >
            {{ labelCheckList.filter((it) => +it.type === +item)[0].name }}
          </el-tag>
        </span>
      </el-form-item>
    </el-form>
    <el-form-item label="选择置顶标签：" v-if="labels.length > 0">
      <el-checkbox-group v-model="form.topLableIds" @change="handleLabelChange">
        <el-checkbox v-for="item in labels" :label="item" :key="item">
          {{ labelCheckList.filter((it) => +it.type === +item)[0].name }}
        </el-checkbox>
      </el-checkbox-group>
    </el-form-item>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="cancel">取 消</el-button>
      <el-button type="primary" size="small" @click="save">保存</el-button>
    </div>
    <el-button
      style="margin: 20px 0 10px 0"
      @click="showLogData"
      :loading="logLoading"
      size="small"
      type="primary"
    >
      操作日志
      <i class="el-icon-arrow-right" v-if="!showLog"></i>
      <i class="el-icon-arrow-down" v-else></i>
    </el-button>
    <transition name="el-fade-in-linear">
      <operation-log v-show="showLog" :visible="showLog" :flightPlanId="this.flightId" />
    </transition>
    <AddLabel ref="addLabel" @close="getLabelList" />
  </el-dialog>
</template>

<script>
  import {
    getSeatSelect,
    getSeatNumSelect,
    priceSchemeList,
    getFlightDetailsById,
    editFlight,
    labelList
  } from '@/api/transport/bustime'
  import modifyDriver from './modify-driver'
  import dayjs from 'dayjs'
  import useHandleLabel from './hooks/useLabel.js'
  import OperationLog from '@/components/logInfo/list'
  import AddLabel from './add-label.vue'

  export default {
    name: 'runningplanEdit',
    filters: {},
    components: {
      modifyDriver,
      OperationLog,
      AddLabel
    },
    data() {
      return {
        topLableIds: [],
        // labelCheckFlag: false,
        labelVisible: false,
        labelCheck: [],
        labels: [],
        visible: true,
        carTypeDisabled: true,
        modifyDriverDialog: false,
        start: 0, // 默认起点
        end: 1, // 终点计算列表长度
        title: '',
        times: '',
        seatDic: [], // 车座
        carTypeDic: [], // 车型
        priceMethodDic: [], // 价格方案
        form: {},
        data: [],
        info: {},
        flightId: '',
        seats: '',
        merchantId: '',
        lineId: '',
        timeRangeShow: false,
        logLoading: false,
        showLog: false,
        labelCheckList: [],
        labelLoading: false
      }
    },
    setup() {
      const { getLabelName } = useHandleLabel()
      return {
        getLabelName
      }
    },
    watch: {
      // labelCheck: {
      //   handler(newVal) {
      //     if (newVal.length > 1) {
      //       console.log('newVal', newVal, this.labelCheckList)
      //       const nameList = []
      //       const list = []
      //       newVal.forEach((id) => {
      //         this.labelCheckList.forEach((item) => {
      //           if (id === parseInt(item.id)) {
      //             list.push(item)
      //           }
      //         })
      //       })
      //       list.forEach((item) => {
      //         if (item.position === 1) {
      //           nameList.push(item.name)
      //         }
      //       })
      //       if (nameList.length > 1) {
      //         this.labelCheckFlag = true
      //         this.$message.error(`只能选择一个标签置顶，当前${nameList.join('、')}标签选择了置顶`)
      //       } else {
      //         this.labelCheckFlag = false
      //       }
      //     } else {
      //       this.labelCheckFlag = false
      //     }
      //   },
      //   deep: true
      // }
    },
    methods: {
      handleLabelChange(newVal) {
        // 如果选择了新的选项（从选中1个变成选中2个）
        if (newVal.length > 1) {
          // 只保留最后一个选中的
          const lastSelected = newVal[newVal.length - 1]
          this.form.topLableIds = [lastSelected]
        }
      },
      topLableIdsChange(checked, currentItem, row) {
        if (checked && row.topLableIds.length === 2) {
          this.$message.error('只能选择一个标签置顶')
          const index = row.topLableIds.findIndex((val) => val === currentItem)
          row.topLableIds.splice(index, 1)
        }
      },
      timeRangeChange(val) {
        this.form.adjustTime = (val[0] - val[1]) / 60000
      },
      submitLabel() {
        this.labels = this.labelCheck
        this.labelVisible = false
      },
      addLabels() {
        this.labelVisible = !this.labelVisible
        this.labels.forEach((it, i) => {
          this.labels[i] = +it
        })
        this.labelCheck = this.labels
        this.getLabelList()
      },
      handleCloseLabel(index) {
        this.labels.splice(index, 1)
      },
      init(row) {
        console.log('row', row)
        this.visible = true
        this.title = '编辑班次详情'
        this.data = []
        this.info = row
        this.flightId = row.flightId

        this.lineId = row.lineId
        this.merchantId = row.merchantId
        this.seats = row.seat

        // 查询详情
        this.getDetails(row.flightId)
        getSeatSelect().then((resp) => {
          this.seatDic = resp.data
        })
        this.getLabelList()
      },
      getDetails(id) {
        getFlightDetailsById(id).then((resp) => {
          if (resp.data.labels.length > 0) {
            this.labels = resp.data.labels
          }

          this.form = resp.data
          if (!this.form.topLableIds) {
            this.$set(this.form, 'topLableIds', [])
          }

          if (resp.data.adjustTime < 0) {
            const time = dayjs(resp.data.departureDate + ' ' + resp.data.departureTime).add(
              resp.data.adjustTime,
              'minute'
            )
            const startTime = dayjs(time).valueOf()
            this.$set(this.form, 'timeRange', [])
            this.form.timeRange.push(startTime)
            this.form.timeRange.push(
              dayjs(resp.data.departureDate + ' ' + resp.data.departureTime).valueOf()
            )
            this.timeRangeShow = true
          }
          const list = resp.data.stationInfoVOS
          list.forEach((item, index) => {
            const fields = {
              index,
              stationId: item.stationId,
              stationName: item.stationName,
              rule: item.rule,
              mileage: item.mileage,
              startTime: item.startTime,
              isOpen: item.isOpen,
              sort: item.sort,
              enable: item.enable,
              arrTime: item.arrTime,
              endTime: item.endTime,
              pickUpType: item.pickUpType,
              openPickUp: item.openPickUp
            }
            this.data.push(fields)
          })
          this.end = this.data.length - 1
        })
      },
      handlePlanTime(val) {
        this.form.departureTime = val + ':00'
      },
      // 下拉获取车型
      handleSeateNumSelect(val) {
        this.carTypeDisabled = false
        if (!val) {
          return
        }
        getSeatNumSelect(val).then((resp) => {
          this.carTypeDic = resp.data
        })
      },
      handleSelectPriceMthod(val) {
        const params = {
          current: 1,
          size: 9999,
          lineId: this.lineId,
          merchantId: this.merchantId,
          seats: this.seats === null ? '' : this.seats,
          type: val
        }
        priceSchemeList(params).then((resp) => {
          this.priceMethodDic = resp.data
        })
      },

      save() {
        if (this.timeRangeShow) {
          this.form.departureTime = dayjs(this.form.timeRange[1]).format('HH:mm') + ':00'
        } else {
          this.form.adjustTime = 0
        }

        this.form.editFlightStationInfos = this.data
        this.form.labels = this.labels
        editFlight(this.form).then((resp) => {
          if (resp.code === 0) {
            this.$message.success('编辑成功')
            this.labels = []
            this.labelCheck = []
            this.visible = false
            this.showLog = false
            this.timeRangeShow = false
            this.data = []
            this.$emit('refreshDetailsData')
            this.labelVisible = false
          }
        })
      },
      cancel() {
        this.timeRangeShow = false
        this.form = {}
        this.labels = []
        this.labelCheck = []
        this.visible = false
        this.showLog = false
        this.labelVisible = false
      },
      // 获取价格方案
      getPriceMethodList(params = {}) {
        priceSchemeList(params).then((resp) => {
          this.priceMethodDic = resp.data
        })
      },
      handleMmpVar() {
        this.modifyDriverDialog = true
        this.$nextTick(() => {
          const params = {
            merchantId: this.info.merchantId,
            priceMethodId: this.info.priceMethodId,
            flightPlanId: this.flightId,
            lineId: this.info.lineId
          }
          this.$refs.modifyDriver.init(params)
        })
      },
      refreshData() {
        this.data = []
        this.getDetails(this.flightId)
      },
      handleClose(done) {
        this.timeRangeShow = false
        this.form = {}
        this.data = []
        this.visible = false
        this.showLog = false
        done()

        this.labelVisible = false
      },
      showLogData() {
        this.showLog = !this.showLog
      },
      async getLabelList() {
        try {
          this.labelLoading = true
          const { code, data } = await labelList()
          if (code !== 0) return
          this.labelCheckList = data
        } catch (error) {
          console.log(error)
        } finally {
          this.labelLoading = false
        }
      },
      handleAdd(row, type) {
        this.$refs.addLabel.init(row, type)
      }
    }
  }
</script>

<style scoped>
  .tipsBox {
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #9f9f9f;
  }
  .tipsBox span {
    margin-left: 5px;
  }
  .add-labels {
    color: #e6a23c;
    text-decoration: underline;
    margin-right: 10px;
    cursor: pointer;
  }
  ::-webkit-scrollbar {
    width: 10px;
  }
</style>
